module.exports = __webpack_public_path__ + "static/img/103352.ae845bec.png";